<template>
  <tbody>
  <!-- <tbody is="draggable" v-model="food_choices" handle=".handle" tag="tbody" @change="sortChanged"> -->
    <tr v-for="(exercise, index) in exercises" v-bind:key="index">
      <td>
        <!-- <i class="mdi mdi-drag handle" v-if="exercises.length>1"></i> -->
        <a href="#" @click.prevent="deleteExerciseFromGroup(exercise)"><i class="mdi mdi-close"></i></a>
      </td>
      <td>{{ exercise.name }}</td>
      <td class="text-right">
        <a href="#"
          @click.prevent="startEditingExerciseSets(exercise)"
          v-show="exerciseSetsEditId != exercise.pivot.id">
          {{exercise.pivot.sets | toFixed}}
        </a>

        <input type="number"
          :id="'edit-exercise-sets-'+exercise.pivot.id"
          v-model.number="newSetsAmount"
          v-show="exerciseSetsEditId == exercise.pivot.id"
          @keydown.enter="updateExerciseSets(exercise)"
          @keydown.esc="cancelEditingExerciseSets"
          @blur="cancelEditingExerciseSets"
          min="0"
          max="255"
          step="1"
          style="height: 24px; width: 3rem; padding: 2px 1px; font-size: 15px;"
        >
      </td>
      <td class="text-right">
        <a href="#"
          @click.prevent="startEditingExerciseReps(exercise)"
          v-show="exerciseRepsEditId != exercise.pivot.id">
          {{exercise.pivot.reps | toFixed}}
        </a>

        <input type="number"
          :id="'edit-exercise-reps-'+exercise.pivot.id"
          v-model.number="newRepsAmount"
          v-show="exerciseRepsEditId == exercise.pivot.id"
          @keydown.enter="updateExerciseReps(exercise)"
          @keydown.esc="cancelEditingExerciseReps"
          @blur="cancelEditingExerciseReps"
          min="0"
          max="255"
          step="1"
          style="height: 24px; width: 3rem; padding: 2px 1px; font-size: 15px;"
        >
        <!-- Rep unit -->
        <!-- <a href="" v-if="exercise.pivot.rep_unit">{{ exercise.pivot.rep_unit }}</a> -->
        <a href="#"
          @click.prevent="startEditingExerciseRepUnit(exercise)"
          v-show="exerciseRepUnitEditId != exercise.pivot.id">
          {{ exercise.pivot.rep_unit || 'x' }}
        </a>
        <select
          :id="'edit-exercise-rep-unit-'+exercise.pivot.id"
          v-model="newRepUnit"
          v-show="exerciseRepUnitEditId == exercise.pivot.id"
          @change="updateExerciseRepUnit(exercise)"
          @blur="cancelEditingExerciseRepUnit"
        >
          <option value="x">x</option>
          <option value="ea">ea</option>
          <option value="sec">sec</option>
          <option value="min">min</option>
        </select>
      </td>
      <!-- <td class="text-right">
        <select name="" id="">
          <option value="times">x</option>
          <option value="each">ea</option>
          <option value="seconds">sec</option>
          <option value="minutes">min</option>
        </select>
      </td> -->
      <td class="text-right">
        <a href="#"
          @click.prevent="startEditingExerciseRest(exercise)"
          v-show="exerciseRestEditId != exercise.pivot.id">
          {{exercise.pivot.rest | toFixed}}
        </a>
        <!-- Using a form would let us use the browser validation. But it's too rigid (validating steps) -->
        <!-- <form @submit.prevent="updateExerciseRest(exercise)" style="display:inline;"> -->
        <input type="number"
          :id="'edit-exercise-rest-'+exercise.pivot.id"
          v-model.number="newRestAmount"
          v-show="exerciseRestEditId == exercise.pivot.id"
          @keydown.enter="updateExerciseRest(exercise)"
          @keydown.esc="cancelEditingExerciseRest"
          @blur="cancelEditingExerciseRest"
          min="0"
          max="255"
          step="15"
          style="height: 24px; width: 3rem; padding: 2px 1px; font-size: 15px;"
        >s
      </td>
      <!-- <td class="text-right">{{ exercise.pivot.reps }}</td> -->
      <!-- <td class="text-right">{{ exercise.pivot.rest }}s</td> -->
    </tr>
  </tbody>
</template>
<script>
import store from "@coach/js/store/store";
import draggable from 'vuedraggable'
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      exerciseSetsEditId: -1,
      exerciseRepsEditId: -1,
      exerciseRepUnitEditId: -1,
      exerciseRestEditId: -1,
      newSetsAmount: 0,
      newRepsAmount: 0,
      newRepUnit: 'x',
      newRestAmount: 0
    }
  },
  components: {
    draggable
  },
  computed: {
    ...mapGetters("plan", {
      workoutPlan: 'workoutPlan',
      planStoreError: 'error'
    })
  },
  methods: {
    deleteExerciseFromGroup(exercise) {
      var _this = this;
      this.$store.dispatch("plan/deleteWorkoutPlanExercise", exercise.pivot.id);
    },
    startEditingExerciseSets(exercise) {
      this.exerciseSetsEditId = exercise.pivot.id;
      this.newSetsAmount = exercise.pivot.sets;
      this.$nextTick(function(){
          document.getElementById('edit-exercise-sets-'+this.exerciseSetsEditId).select();
      }.bind(this))
    },
    updateExerciseSets(excercise) {
      var _this = this;

      if (!_.inRange(_this.newSetsAmount, 1, 256)) {
        _this.$toasted.error("Sets must be between 1 and 255");
        return;
      }

      this.$store.dispatch("plan/updateWorkoutPlanExercise", {
        "id": excercise.pivot.id,
        "sets": _this.newSetsAmount}
      ).then(() => {
        _this.cancelEditingExerciseSets();
        if (_this.planStoreError) {
          _this.$toasted.error(this.planStoreError);
        }
      });
    },
    cancelEditingExerciseSets() {
      this.exerciseSetsEditId = -1
    },
    startEditingExerciseReps(exercise) {
      this.exerciseRepsEditId = exercise.pivot.id;
      this.newRepsAmount = exercise.pivot.reps;
      this.$nextTick(function(){
          document.getElementById('edit-exercise-reps-'+this.exerciseRepsEditId).select();
      }.bind(this))
    },
    updateExerciseReps(excercise) {
      var _this = this;

      if (!_.inRange(_this.newRepsAmount, 1, 256)) {
        _this.$toasted.error("Reps must be between 1 and 255");
        return;
      }

      this.$store.dispatch("plan/updateWorkoutPlanExercise", {
        "id": excercise.pivot.id,
        "reps": _this.newRepsAmount}
      ).then(() => {
        _this.cancelEditingExerciseReps();
        if (_this.planStoreError) {
          _this.$toasted.error(this.planStoreError);
        }
      });
    },
    cancelEditingExerciseReps() {
      this.exerciseRepsEditId = -1
    },
    startEditingExerciseRepUnit(exercise) {
      this.exerciseRepUnitEditId = exercise.pivot.id;
      this.newRepUnit = exercise.pivot.rep_unit;
      this.$nextTick(function(){
        document.getElementById('edit-exercise-rep-unit-'+this.exerciseRepUnitEditId).focus();
      }.bind(this))
    },
    updateExerciseRepUnit(excercise) {
      var _this = this;
      this.$store.dispatch("plan/updateWorkoutPlanExercise", {
        "id": excercise.pivot.id,
        "rep_unit": _this.newRepUnit}
      ).then(() => {
        _this.cancelEditingExerciseRepUnit();
        if (_this.planStoreError) {
          _this.$toasted.error(this.planStoreError);
        }
      });
    },
    cancelEditingExerciseRepUnit() {
      this.exerciseRepUnitEditId = -1
    },
    startEditingExerciseRest(exercise) {
      this.exerciseRestEditId = exercise.pivot.id;
      this.newRestAmount = exercise.pivot.rest;
      this.$nextTick(function(){
          document.getElementById('edit-exercise-rest-'+this.exerciseRestEditId).select();
      }.bind(this))
    },
    updateExerciseRest(excercise) {
      var _this = this;

      if (!_.inRange(_this.newRestAmount, 0, 256)) {
        _this.$toasted.error("Rest must be between 0 and 255");
        return;
      }

      this.$store.dispatch("plan/updateWorkoutPlanExercise", {
        "id": excercise.pivot.id,
        "rest": _this.newRestAmount}
      ).then(() => {
        _this.cancelEditingExerciseRest();
        if (_this.planStoreError) {
          _this.$toasted.error(this.planStoreError);
        }
      });
    },
    cancelEditingExerciseRest() {
      this.exerciseRestEditId = -1
    },
  },
  props: [
      'exercises'
  ],
  filters: {
    // properCase(string) {
    //   return string.charAt(0).toUpperCase() + string.slice(1);
    // }
  }
}
</script>
<style></style>
